// Utilidades compartidas para la generación e impresión de actas de entrega.
// Antes estaban duplicadas en TecnicoPage.js, RecursosHumanosPage.js y Clientes.js;
// se centralizan aquí para que el logo, el escape y la impresión no se desincronicen.

export const SUTRAK_LOGO = window.location.origin + '/logos/sutrak.png';

export const isSutrak = value => String(value || '').trim().toUpperCase().includes('SUTRAK');

export const htmlEscape = value =>
  String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

// Abre una ventana nueva y escribe el HTML del acta (el propio HTML dispara window.print()).
export function imprimirHTML(html) {
  const w = window.open('', '_blank');
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
}
